import Jsona from 'jsona';

export const strict = false;
export const type = 'team-members';

export const ALL = 'ALL';
export const GET = 'GET';
export const SET_TEAM_MEMBERS = 'SET_TEAM_MEMBERS';

export const state = () => ({
  data: []
});

export const actions = {
  async [GET]({ getters, state, commit }, { emails }) {
    const promises = emails.map(email => this.$axios.$get(
      'api/v1/appointments/team_member', { params: { email } }
    ));
    const responses = await Promise.all(promises);

    commit(SET_TEAM_MEMBERS, responses.map(response => new Jsona().deserialize(response)).flat());
  }
};

export const mutations = {
  [SET_TEAM_MEMBERS](state, users) {
    state.data = users;
  }
};

export const getters = {
  [ALL](state, getters) {
    return state.data.map(user => ({ ...user, companyId: user.company.id }));
  }
};
